import axios from 'axios';
import React, { useState, useRef, useEffect } from 'react';
import {
  Link,
  useParams,
  useNavigate,
  useLocation
} from "react-router-dom";
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamationTriangle, faPlus, faMinus, faSpinner } from '@fortawesome/free-solid-svg-icons';
import "../css/spinner.css";
import { useAuth } from '@zones-digital-platform/react-oidc-auth';

export default function Edit() {
  const poUrl = process.env.REACT_APP_INTERNAL_PO;
  const postUrl = process.env.REACT_APP_INTERNAL_UO;
  const carrierUrl = process.env.REACT_APP_INTERNAL_COURIERS;
  const dataApi = process.env.REACT_APP_DATA_FIELD;
  const mapKey = process.env.REACT_APP_G_KEY;
  const customerProductMapping = process.env.REACT_APP_INTERNAL_UPDATE_CUSTOMER_PRODUCT_MAPPING;


  const { id } = useParams(); // get the id from the URL parameter
  const [post, setPost] = useState({}); // initialize state for the post
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loadingIcon, setLoadingIcon] = useState('');
  const [courierLoader, setCourierLoader] = useState(false);
  const [couriers, setCouriers] = useState({});
  const [open, setOpen] = useState(false);
  const assetResponse = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, logout, getToken } = useAuth();


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {

    fetch(`${poUrl}/${id}`, {
      headers: {
        'Authorization': `Bearer ${getToken()}`,
      },
    })
      .then(response => response.json())
      .then(data => setPost(dataApi ? data[dataApi] : data))
      .catch(error => console.log(error));
  };

  const orderLinesData = post.orderLevels?.[0]?.orderLines || []; // Safely access orderLines


  const extractedOrderLines = [].concat(
    ...((post.orderLevels || []).map(orderLevel =>
      (orderLevel.orderLines || []).map(orderLine => ({
        extCustomerId: post.extCustomerId,
        extCustomerMappingId: post.extCustomerMappingId,
        customerProductReference: orderLine.customerPartNumber,
        isAsset: orderLine.isAsset,
        customerProductName: orderLine.customerProductDescription,
        customerCategory: orderLine.customerCategory,
        zonesPartNumber: orderLine.zonesPartNumber || null
      }))
    ) || [])
  );



  // State to manage the asset status
  const [orderLines, setOrderLines] = useState(extractedOrderLines);

  //console.log(orderLines);
  // Function to handle checkbox change
  const handleCheckboxChange = (index) => {
    const updatedOrderLines = [...orderLinesData];
    updatedOrderLines[index].isAsset = !updatedOrderLines[index].isAsset; // Toggle isAsset
    setOrderLines(updatedOrderLines);
    console.log(updatedOrderLines);
  };

  // get carrier dropdown list
  useEffect(() => {
    if (post && post.extCustomerMappingId) {
      fetch(
        `${carrierUrl}?countryCode=${post.extCustomerMappingId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
        .then(response => response.json())
        .then(data => {
          setCouriers(data.data);
          setCourierLoader(true);
          // console.log(data.data);
        })
        .catch(error => {
          console.error('Error fetching couriers:', error);
        });
    }
  }, [post]);


  const handleAsset = (event) => {
    setOpen(true);
  };
  const closePopup = () => setOpen(false);

  const handleAssetResponse = (event) => {

    const match = location.pathname.match(/\/edit\/(\d+)/);
    const id = match ? match[1] : null;

    const innerText = event.target.innerText.toLowerCase();

    // Check if the innerText is "yes"
    if (innerText === "yes") {


      // Perform the POST request
      fetch(`${customerProductMapping}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        },
        body: JSON.stringify(extractedOrderLines),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Success:', data);
          handleEditSave();
          navigate(`/poview/${id}`);
        })
        .catch((error) => {
          console.error('Error:', error);
        });

    } else {
      console.log('The innerText is not "yes".');
      navigate(`/poview/${id}`);
    }



  }


  const handleEditSave = async () => {
    const postData = {
      poNumber: post.poNumber,
      extCustomerId: post.extCustomerId,
      extCustomerMappingId: post.extCustomerMappingId,
      orderLinesDetail: []
    };

    post.orderLevels[0].orderLines.forEach((line, lIndex) => {
      line.lineDetails.forEach((detail) => {
        if (Object.values(detail).some(val => val)) {
          // clear asstet tag if toggled off
          if (!line.isAsset) {
            detail.assetTag = '';
            detail.serialNumber = '';
          }

          const updatedDetail = {};
          Object.entries(detail).forEach(([key, value]) => {
            if (line.quantity > 1) {
              if (value !== '') {
                updatedDetail[key] = key === 'quantity' ? parseInt(value) : value;
              } else if (key === 'quantity') {
                updatedDetail[key] = 1; // Set default value to '1' if quantity is empty
              }
            } else {
              updatedDetail[key] = key === 'quantity' ? parseInt(value) : value;
            }
          });
          postData.orderLinesDetail.push({
            orderLevelSequence: post.orderLevels[0].orderLevelSequence,
            orderLineSequence: line.orderLineSequence,
            lineDetailId: detail.lineDetailId,
            extPoLineNumber: line.extPoLineNumber,
            ...updatedDetail
          });
        }
      });
    });

    // console.log(postData);
    fetch(postUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getToken()}`
      },
      body: JSON.stringify(postData)
    })
      .then(res => {
        // console.log(res);
        setLoadingIcon('');
        setSuccessMessage('Data saved successfully!');
        fetchData();
      })
      .catch(err => {
        console.log(err);
      });
  };


  if (!post.orderLevels) {
    return <div className="spinner-container">
      <div className="loading-spinner">
      </div>
    </div>;
  }

  return (
    <div className="relative shadow-md">
      <section className='cont-wrapper'>
        <nav className="border-gray-200 bg-z-blue dark:bg-blue-800 dark:border-gray-700 px-6">
          <div className="flex flex-wrap items-center justify-between mx-auto p-4">
            <a href="/" className="flex items-center">
              <img src={require('../images/zones_logo_white.png')} style={{ height: '20px', marginRight: '25px', marginLeft: '5px' }} alt="Zones Logo" />
              <span className="self-center text-3xl font-semibold text-white whitespace-nowrap dark:text-white">Purchase Order </span><span className="ml-4 self-center text-3xl text-white whitespace-nowrap dark:text-white">{post.poNumber}</span>
              <p className={successMessage ? "fade-out" : "fa-hidden"}>{successMessage} <FontAwesomeIcon icon={faCheck} /></p>
              <p className={errorMessage ? "show-err" : "fa-hidden"}>{errorMessage} <FontAwesomeIcon icon={faExclamationTriangle} /></p>
              <p className={loadingIcon ? "loading" : "fa-hidden"}>{loadingIcon} <FontAwesomeIcon icon={faSpinner} pulse /></p>
            </a>
            <div className="flex md:order-2">
              <Link to={`/poview/${id}`}><button type="button" className="text-white bg-slate-300 hover:bg-slate-200 focus:ring-2 focus:outline-none focus:ring-white font-medium rounded-lg text-md px-8 py-4 text-center mr-3 md:mr-0 dark:bg-white-600 dark:hover:bg-sky-300 dark:focus:ring-z-blue">Back</button></Link>
              <button onClick={handleAsset} type="button" className="text-white bg-emerald-400 hover:bg-emerald-300 focus:ring-2 focus:outline-none focus:ring-white font-medium rounded-lg text-md px-8 py-4 text-center mr-3 ml-8 md:mr-0 dark:bg-white-600 dark:hover:bg-blue-300 dark:focus:ring-z-blue">Save</button>
            </div>
          </div>
        </nav>
      </section>
      <section className="table-wrap-1 shadow-md sm:rounded-lg">
        {post.orderLevels && post.orderLevels.length ?
          <table className="text-md text-left text-gray-500 dark:text-gray-400">

            <thead className="text-md text-z-blue uppercase bg-gray-100 dark:bg-blue-700 dark:text-white">
              <tr>
                <th scope="col" className="pl-12 pr-0 py-4 pl-1 w-4/12">Item</th>
                <th scope="col" className="px-1 py-4 pl-12 w-4/12">Part #</th>
                <th scope="col" className="px-1 py-4 pl-12 w-4/12"> Is this an Asset?</th>
              </tr>
            </thead>
            <tbody>
              {extractedOrderLines.map((order, index) => (
                <tr key={index}>
                  <td className="pl-12 pr-0 py-6 pl-1">{order.customerProductName}</td>
                  <td className="pl-12 px-1 py-6">{order.customerProductReference}</td>
                  <td className="pl-12 px-1 py-6">
                    <div className='input-wrap'>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={order.isAsset}
                          onChange={() => handleCheckboxChange(index)} />
                        <span className="slider round"></span>
                      </label>
                    </div>

                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          : <div></div>}
      </section>
      {
        open && <div className="relative z-10 asset-modal" aria-labelledby="modal-title" role="dialog" aria-modal="true" onClick={closePopup}>
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto" >
            <div className="flex min-h-50 items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <h2 className="text-base font-semibold leading-6 text-gray-900" id="modal-title">Do you want to save all the assets?</h2>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button type="button" className="text-white bg-emerald-400 hover:bg-emerald-300 focus:ring-2 focus:outline-none focus:ring-white font-medium rounded-lg text-md px-8 py-4 text-center mr-3 ml-8 md:mr-0 dark:bg-white-600 dark:hover:bg-blue-300 dark:focus:ring-z-blue" onClick={(event) => handleAssetResponse(event)}>Yes</button>
                  <button type="button" className="text-white bg-slate-300 hover:bg-slate-200 focus:ring-2 focus:outline-none focus:ring-white font-medium rounded-lg text-md px-8 py-4 text-center mr-3 md:mr-0 dark:bg-white-600 dark:hover:bg-sky-300 dark:focus:ring-z-blue" onClick={(event) => handleAssetResponse(event)}>No</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}